module.exports = __webpack_public_path__ + "static/media/icon_exit_app.26b95e23.svg";